import { useEffect } from 'react';
import ScaffoldPage from '../_ScaffoldPage';
export default function DCFModelPage() {
  useEffect(() => { document.title = 'DCF Valuation Model — Intrinsic Value Calculator for Stocks | Nuvport OS'; }, []);
  return <ScaffoldPage badge="DCF MODEL" title="Calculate intrinsic value. Know what a stock is actually worth." description="Build a full discounted cash flow model for any stock in the Nuvport universe. Adjust growth rates, discount rates, and terminal values in real time." canonical="/features/dcf-model" />;
}
